module.exports = __webpack_public_path__ + "images/right-white-ext-link.36daa78174.svg";